<div
    class="t-circle"
    [style.left.%]="left"
    [style.top.%]="top"
></div>
